import * as yup from 'yup';

export const InspectionSchema = yup.object({
  id: yup.number(),
  uuid: yup.string(),
  solar_farm_id: yup.number(),
  solar_farm_uuid: yup.string(),
  org_id: yup.number(),
  name: yup.string(),
  creator_id: yup.number(),
  status: yup.number(),
  created_tsecs: yup.number(),
  updated_tsecs: yup.number().nullable(),
  verified: yup.boolean(),
  inspection_tsecs: yup.number().nullable(),
  timezone: yup.string().nullable(),
  power_inspected: yup.number().nullable(),
  summary_text: yup.string().nullable(),
  title: yup.string().nullable(),
  temperature: yup.number().nullable(),
  rel_humidity: yup.number().nullable(),
  cloud_cover: yup.string().nullable(),
  wind_speed: yup.number().nullable(),
  uas_model: yup.string().nullable(),
  imaging_system: yup.string().nullable(),
  localize_description: yup.string().nullable(),
  notation: yup.string().nullable(),
  contact_uuid: yup.string().nullable(),
  peak_sunlight: yup.number().nullable(),
  anomaly_map_description: yup.string().nullable(),
  site_overview_visible: yup.boolean(),
  findings_visible: yup.boolean(),
  anomaly_examples_visible: yup.boolean(),
  data_capture_visible: yup.boolean(),
  localize_anomalies_visible: yup.boolean(),
  anomaly_map_visible: yup.boolean(),
  anomaly_locations_visible: yup.boolean(),
  annual_monetary_impact_visible: yup.boolean(),
  annual_power_impact_visible: yup.boolean(),
  version: yup.number(),
  order_uuid: yup.string(),
  delta_t_visible: yup.boolean(),
  thermal_overlay_visible: yup.boolean(),
  workflow_status: yup.number(),
  flight_boundary: yup
    .object({
      type: yup.string().nullable(),
      coordinates: yup
        .array()
        .of(yup.array().of(yup.number()).defined())
        .defined(),
    })
    .nullable(),
  inspection_tsecs_end: yup.number().nullable(),
  defect_action_visible: yup.number(),
  quality_checked: yup.number(),
  ppa_rate: yup.number().nullable(),
});

export type Inspection = yup.InferType<typeof InspectionSchema>;
